import React, { useState, useEffect } from 'react';

import Label from '../../../../Components/Label';
import InputField from '../../../../Components/InputField';
import DateRangePicker1 from '../../../../Components/dateRangePicker1';
import TimeRangePicker from '../../../../Components/timeRangePicker';
import Select3 from '../../../../Components/Select3';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import { format } from 'date-fns';

import '../../../../Assets/css/toast.css';

const UnitCreateBounding = () => {
    const token = localStorage.getItem('unittoken');
    const decodedToken = jwtDecode(token);
    const userId = { userID: decodedToken.id };
    const button = {};

    const [checkedTriggerMethod, setCheckedTriggerMethod] = useState(true);

    const [checkedMonday, setCheckedMonday] = useState(true);
    const [checkedTuesday, setCheckedTuesday] = useState(true);
    const [checkedWednesday, setCheckedWednesday] = useState(true);
    const [checkedThursday, setCheckedThursday] = useState(true);
    const [checkedFridy, setCheckedFridy] = useState(true);
    const [checkedSaturday, setCheckedSaturday] = useState(true);
    const [checkedSunday, setCheckedSunday] = useState(true);

    const [checkedUser, setCheckedUser] = useState(false);

    const [boundingSelect, setBoundingSelect] = useState('');
    const mapapikey = "AIzaSyDAAlxMo2YYJiqu8tJovNqNgFenMDM1oGU";
    const mapSrc = "https://www.google.com/maps/embed/v1/place?key=AIzaSyBECMJIvTTyCe5Cu-i-w0PfGN64TsIjEtg&q=Washington,+DC";

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const [boundingData, setBoundingData] = useState({
            serial_number:'',
            userId:userId.userID,
            geo_fence_name:'',
            number_of_member:'',
            trigger_method:'',
            dispatcher:'',
            member:'',
            effective_day:'',
            effective_period:'',
            ciricle_bound:'',
            creation_date:formattedDate,
        }); 

    const handleBoundingChange = (e) => {
        setBoundingData({
            ...boundingData,
            [e.target.name]: e.target.value,
        });
    };

    const handleTriggerMethod1 = () => {
        setBoundingData({
            ...boundingData,
            ['trigger_method']: 'Enter warning',
        });
    }
    const handleTriggerMethod2 = () => {
        setBoundingData({
            ...boundingData,
            ['trigger_method']: 'Exit warning',
        });
    }

    

    const formatStr = 'YYYY-MM-DD'; // Date-only format
    function format(value) {
        return value ? value.format(formatStr) : ''; // Only return the date portion
      }
      
    const handleDataFromChild1 = (data) => {
        console.log('data',format(data[0]),format(data[1]));
    }

    return (
        <>
            <div className='relative w-full h-[calc(100%-25px)] mt-[10px]'>
                <div class={`absolute ${boundingSelect === '' ? 'w-[466px]' : 'w-[821px]'} top-5 right-5 h-[510px] bg-[transparent] flex`}>
                    {/* -------------dispatcher------------- */}
                    {boundingSelect === 'dispatcher' &&
                        <div className='w-[355px] h-full border-r border-r-[#c2c2c2] bg-[white]'>
                            <div className='w-full text-center h-[34px] leading-[34px] text-[16px] text-[white] bg-[#2776c3]' style={{ fontFamily: 'Liberation Serif' }}>Selected dispatcher</div>
                            <div class="p-[15px] border-b border-b-[#c2c2c2]">
                                <div className='flex'>
                                    <div class="relative text-[14px] inline-block !m-0">
                                        <input type='text' placeholder='please input the dispatcher name' class="pl-3 inline-block w-[279px] h-[40px] bg-white border border-[#dcdfe6] rounded-tl-[4px] rounded-bl-[4px]] box-border text-black outline-0" />
                                    </div>
                                    <span class="bg-[#2776c3] text-[#ffffff] p-0 px-[4px] text-center w-[50px] !h-[40px] leading-[40px] rounded-tr-[4px] rounded-br-[4px] cursor-pointer text-[14px]">Search</span>
                                </div>
                            </div>
                            <div class="p-[15px] h-[calc(100%-180px)] text-[#5a5655] text-[14px]" >
                                <div class="h-full overflow-y-auto">
                                    <div class="inline-block leading-none align-middle text-[0]">
                                        <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }} onClick={() => setCheckedUser(!checkedUser)}>
                                            <div className="flex items-center mb-4">
                                                {checkedUser === true ?
                                                    <svg
                                                        className="w-[23px] h-[23px] outline-none"
                                                        focusable="false"
                                                        viewBox="0 0 24 24"
                                                        data-testid="CheckCircleIcon"
                                                        fill='#56ab8a'
                                                    >
                                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                    </svg>
                                                    :
                                                    <svg
                                                        className="w-[23px] h-[23px] outline-none"
                                                        focusable="false"
                                                        viewBox="0 0 24 24"
                                                        data-testid="RadioButtonUncheckedIcon"
                                                        title="RadioButtonUnchecked"
                                                        fill='#5a5655'
                                                    >
                                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                    </svg>
                                                }
                                                <input
                                                    disabled
                                                    id="disabled-checkbox"
                                                    type="checkbox"
                                                    value={checkedUser}
                                                    checked={checkedUser}
                                                    onChange={() => setCheckedUser(!checkedUser)}
                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                    style={{ display: 'none' }}
                                                />
                                                <label
                                                    htmlFor="disabled-checkbox"
                                                    className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                >
                                                    User01
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* ------------add memeber-------------- */}
                    {boundingSelect === 'member' &&
                        <div className='w-[355px] h-full border-r border-r-[#c2c2c2] bg-[white]'>
                            <div className='w-full text-center h-[34px] leading-[34px] text-[16px] text-[white] bg-[#2776c3]' style={{ fontFamily: 'Liberation Serif' }}>Selected   members</div>
                            <div class="p-[15px] border-b border-b-[#c2c2c2]">
                                <div className='flex' style={{ fontFamily: 'Liberation Serif' }}>
                                    <div class="relative  flex text-[14px] inline-block !m-0">
                                        <Select3 options={['Groups','Members']} placeholder={'Groups'} className={'!rounded-tl-[4px] !rounded-bl-[4px] !rounded-tr-[0px] !rounded-br-[0px]'} />
                                        <div className={`w-[180px] m-0 p-0`}>
                                            <div className="relative text-[14px] inline-block w-full">
                                                <input
                                                    type = {'text'}
                                                    placeholder='Please enter the group'
                                                    autoComplete="off"
                                                    className={`w-full bg-white border border-[#dcdfe6] !border-l-[transparent] inline-block text-inherit !h-[40px] leading-[40px] outline-none px-[15px]`}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <span class="bg-[#2776c3] text-[#ffffff] p-0 px-[4px] text-center w-[50px] !h-[40px] leading-[40px] rounded-tr-[4px] rounded-br-[4px] cursor-pointer text-[14px]">Search</span>
                                </div>
                            </div>
                            <div className='ml-2 text-[red] text-[12px] text-center whitespace-nowrap' style={{ fontFamily: 'Liberation Serif' }}>Add the users who activate bounding service in the group</div>
                            <div class="p-[15px] h-[calc(100%-180px)] text-[#5a5655] text-[14px]" >
                                <div class="h-full overflow-y-auto">
                                    <div class="inline-block leading-none align-middle text-[0]">
                                        <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }} onClick={() => setCheckedUser(!checkedUser)} >
                                            <div className="flex items-center mb-4">
                                                {checkedUser === true ?
                                                    <svg
                                                        className="w-[23px] h-[23px] outline-none"
                                                        focusable="false"
                                                        viewBox="0 0 24 24"
                                                        data-testid="CheckCircleIcon"
                                                        fill='#56ab8a'
                                                    >
                                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                    </svg>
                                                    :
                                                    <svg
                                                        className="w-[23px] h-[23px] outline-none"
                                                        focusable="false"
                                                        viewBox="0 0 24 24"
                                                        data-testid="RadioButtonUncheckedIcon"
                                                        title="RadioButtonUnchecked"
                                                        fill='#5a5655'
                                                    >
                                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                    </svg>
                                                }
                                                <input
                                                    disabled
                                                    id="disabled-checkbox"
                                                    type="checkbox"
                                                    value={checkedUser}
                                                    checked={checkedUser}
                                                    onChange={() => setCheckedUser(!checkedUser)}
                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                    style={{ display: 'none' }}
                                                />
                                                <label
                                                    htmlFor="disabled-checkbox"
                                                    className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                >
                                                    Alertline1
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='items center mt-5 flex justify-center'>
                                    <button className='bg-[#2776c3] text-[white] px-3 py-1 rounded' style={{ fontFamily: 'Liberation Serif' }}>Add member</button>
                                </div>
                            </div>
                        </div>
                    }
                    {/* ------------create bounding-------------- */}
                    <div className='flex h-full w-[466px] bg-[white]'>
                        <div className='relative b-[40px] w-full'>
                            <div className='w-full text-center h-[34px] leading-[34px] text-[16px] text-[white] bg-[#2776c3]' style={{ fontFamily: 'Liberation Serif' }}>Create bounding</div>
                            <div className='px-[15px]'>
                                <div className='mt-[15px]'>
                                    <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }}>
                                        <span className='text-[red] pt-[6px]'>*</span>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Geo-Fence Name :
                                        </label>
                                        <div className='relative text-[14px] leading-[40px] !w-[220px]'>
                                            <InputField name = {'geo_fence_name'} value={boundingData.geo_fence_name || ''} onChange={handleBoundingChange} className='!w-[220px]' placeholder={'Please input bound name'} />
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }}>
                                        <span className='text-[red] pt-[6px]'>*</span>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                        >
                                            Trigger method :
                                        </label>
                                        <div className='flex justify-between'>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer items-center' onClick={() => {setCheckedTriggerMethod(true); handleTriggerMethod1()}}>
                                                    <div className="flex items-center mb-4 cursor-pointer">

                                                        {checkedTriggerMethod === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedTriggerMethod}
                                                            checked={checkedTriggerMethod}
                                                            onChange={() =>  {setCheckedTriggerMethod(true);handleTriggerMethod1()}}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[black] mr-2 cursor-pointer"
                                                        >
                                                            Enter warning
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => {setCheckedTriggerMethod(false); handleTriggerMethod2()}}>
                                                    <div className="flex items-center mb-4">
                                                        {checkedTriggerMethod === false ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={!checkedTriggerMethod}
                                                            checked={!checkedTriggerMethod}
                                                            onChange={() => {setCheckedTriggerMethod(false); handleTriggerMethod2()}}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[black] mr-2 cursor-pointer"
                                                        >
                                                            Exit warning
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex items-center' style={{ fontFamily: 'Liberation Serif' }}>
                                        <span className='text-[red] pt-[6px]'>*</span>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Bound admin :
                                        </label>
                                        <div className='w-[108px] h-[28px] flex flex-col justify-center'>
                                            <button onClick={() => setBoundingSelect('dispatcher')} className='bg-[#2776c3] w-full h-[28px] inline-block min-w-[90px] p-[4px] text-[14px] text-[white] text-center cursor-pointer rounded-[4px]' style={{ fontFamily: 'Liberation Serif' }}>
                                                Select dispatcher
                                            </button>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex items-center' style={{ fontFamily: 'Liberation Serif' }}>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Selected members :
                                        </label>
                                        <div className='w-[104px] h-full flex flex-col justify-center'>
                                            <button  onClick={() => setBoundingSelect('member')} className='bg-[#2776c3] w-full h-[28px] inline-block min-w-[90px] p-[4px] text-[14px] text-[white] text-center cursor-pointer rounded-[4px]' style={{ fontFamily: 'Liberation Serif' }}>
                                                Select memebers
                                            </button>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex items-center' style={{ fontFamily: 'Liberation Serif' }}>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Effective Day :
                                        </label>
                                        <div className='w-[104px] h-full flex flex-col justify-center'>
                                            <DateRangePicker1 onSendData={handleDataFromChild1}/>
                                            <div className='ml-2 text-[red] text-[12px] whitespace-nowrap'>No expiry date for those not selected</div>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex items-center' style={{ fontFamily: 'Liberation Serif' }}>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Effective Period :
                                        </label>
                                        <div className='w-[104px] h-full flex flex-col justify-center'>
                                            <TimeRangePicker />
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex items-center' style={{ fontFamily: 'Liberation Serif' }}>
                                        <span className='text-[red] pt-[6px]'>*</span>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                            style={{ fontFamily: 'Liberation Serif' }}
                                        >
                                            Circle the bounds :
                                        </label>
                                        <div className='w-[135px] h-full flex flex-col justify-center'>
                                            <button className='bg-[#2776c3] w-full h-[28px] inline-block min-w-[90px] p-[4px] text-[14px] text-[white] text-center cursor-pointer rounded-[4px]' style={{ fontFamily: 'Liberation Serif' }}>Self-defined selection</button>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }}>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                        >
                                        </label>
                                        <div className='flex justify-between'>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer items-center' onClick={() => setCheckedMonday(!checkedMonday)}>
                                                    <div className="flex items-center mb-4 cursor-pointer">

                                                        {checkedMonday === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedMonday}
                                                            checked={checkedMonday}
                                                            onChange={() => setCheckedMonday(checkedMonday)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer text-[#5a5655]"
                                                        >
                                                            Monday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => setCheckedTuesday(!checkedTuesday)}>
                                                    <div className="flex items-center mb-4">
                                                        {checkedTuesday === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedTuesday}
                                                            checked={checkedTuesday}
                                                            onChange={() => setCheckedTuesday(!checkedTuesday)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                        >
                                                            Tuesday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => setCheckedWednesday(!checkedWednesday)}>
                                                    <div className="flex items-center mb-4">
                                                        {checkedWednesday === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedWednesday}
                                                            checked={checkedWednesday}
                                                            onChange={() => setCheckedWednesday(!checkedWednesday)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                        >
                                                            Wednesday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }}>
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                        >
                                        </label>
                                        <div className='flex justify-between'>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer items-center' onClick={() => setCheckedThursday(!checkedThursday)}>
                                                    <div className="flex items-center mb-4 cursor-pointer">

                                                        {checkedThursday === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedThursday}
                                                            checked={checkedThursday}
                                                            onChange={() => setCheckedThursday(checkedThursday)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer text-[#5a5655]"
                                                        >
                                                            Thursday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => setCheckedFridy(!checkedFridy)}>
                                                    <div className="flex items-center mb-4">
                                                        {checkedFridy === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedFridy}
                                                            checked={checkedFridy}
                                                            onChange={() => setCheckedFridy(!checkedFridy)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                        >
                                                            Friday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex flex-col justify-center'>
                                                <div className='relative text-[14px] h-[20px] cursor-pointer' onClick={() => setCheckedSaturday(!checkedSaturday)}>
                                                    <div className="flex items-center mb-4">
                                                        {checkedSaturday === true ?
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="CheckCircleIcon"
                                                                fill='#56ab8a'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                            </svg>
                                                            :
                                                            <svg
                                                                className="w-[23px] h-[23px] outline-none"
                                                                focusable="false"
                                                                viewBox="0 0 24 24"
                                                                data-testid="RadioButtonUncheckedIcon"
                                                                tabIndex="-1"
                                                                title="RadioButtonUnchecked"
                                                                fill='#5a5655'
                                                            >
                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                            </svg>
                                                        }
                                                        <input
                                                            disabled
                                                            id="disabled-checkbox"
                                                            type="checkbox"
                                                            value={checkedSaturday}
                                                            checked={checkedSaturday}
                                                            onChange={() => setCheckedFridy(!checkedSaturday)}
                                                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                            style={{ display: 'none' }}
                                                        />
                                                        <label
                                                            htmlFor="disabled-checkbox"
                                                            className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                                        >
                                                            Saturday
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='mb-[5px] flex' style={{ fontFamily: 'Liberation Serif' }} >
                                        <label
                                            className={`w-[140px] text-[#5a5655] font-thin text-[14px] leading-[40px] pl-0 pr-3 box-border float-left text-left`}
                                        >
                                        </label>
                                        <div className="flex items-center mb-4" onClick={() => setCheckedSunday(!checkedSunday)}>
                                            {checkedSunday === true ?
                                                <svg
                                                    className="w-[23px] h-[23px] outline-none"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    data-testid="CheckCircleIcon"
                                                    fill='#56ab8a'
                                                >
                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"></path>
                                                </svg>
                                                :
                                                <svg
                                                    className="w-[23px] h-[23px] outline-none"
                                                    focusable="false"
                                                    viewBox="0 0 24 24"
                                                    data-testid="RadioButtonUncheckedIcon"
                                                    tabIndex="-1"
                                                    title="RadioButtonUnchecked"
                                                    fill='#5a5655'
                                                >
                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"></path>
                                                </svg>
                                            }
                                            <input
                                                disabled
                                                id="disabled-checkbox"
                                                type="checkbox"
                                                value={checkedSunday}
                                                checked={checkedSunday}
                                                onChange={() => setCheckedSunday(!checkedSunday)}
                                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                style={{ display: 'none' }}
                                            />
                                            <label
                                                htmlFor="disabled-checkbox"
                                                className="ms-2 text-sm font-medium text-[#5a5655] mr-2 cursor-pointer"
                                            >
                                                Sunday
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full text-center h-[34px] leading-[34px] text-[16px] text-[white] bg-[#2776c3]' style={{ fontFamily: 'Liberation Serif' }}>Create bounding</div>
                        </div>
                    </div>
                </div>
                <div className=' w-full h-full pb-[6px] '>
                    <div id="map" className='w-full h-full'>
                        <iframe
                            title="Google Map"
                            style={{ border: 0, width: '100%', height: '96%' }}
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={mapSrc}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UnitCreateBounding;